export const ACCESS_TOKEN_KEY = `@${__STORAGE_TOKEN_KEY__}`;
export const USER_DATA_KEY = `@${__STORAGE_USER_KEY__}`;
export const SIDEBAR_STATE_KEY = `@wippy/full-sidebar`;
export const SIDEBAR_STATE_WIDTH_KEY = `@wippy/sidebar-width`;

export const QUERY_TOKEN_KEY = `t`; // NOTE: `token` is used in wippy
export const QUERY_EXPIRATION_KEY = `e`;
